"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault"),
    _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react")),
    _classnames = _interopRequireDefault(require("classnames")),
    _progressBar = require("../styles/progressBar");

function ProgressBar(a) {
  var b = a.currentStage,
      c = a.maxStage;
  return _react["default"].createElement("div", {
    className: (0, _classnames["default"])(_progressBar.CONTAINER, "wizard__progress-bar")
  }, _react["default"].createElement("div", {
    className: (0, _classnames["default"])((0, _progressBar.INNER_BAR)(100 * (b / c)), "wizard__progress-bar__progress")
  }));
}

var _default = (0, _react.memo)(ProgressBar);

exports["default"] = _default;